import React from "react";

const BrunetteColorNearMeService = () => {
  return (
    <div className="hairSalonNearMeService">
      <h3>SCENT’s Signature Brunette Hair Color & Highlights Services</h3>
      <p>
        At SCENT, we offer a variety of services to ensure you get the perfect
        brunette hair color & highlights near me. Here are some of our most
        popular options:
      </p>
      <li>
        <h6>Balayage Highlights </h6>
        <p>
          Balayage is a freehand technique that creates a natural, sun-kissed
          effect. It’s perfect for adding subtle highlights that blend
          seamlessly with your brunette base. If you’re looking for
          low-maintenance brunette hair color & highlights near me, balayage is
          a great choice.
        </p>
      </li>
      <li>
        <h6>Babylights</h6>
        <p>
          Babylights are ultra-fine highlights that mimic the natural highlights
          you’d get from the sun. They add dimension and brightness to your
          brunette hair without looking too bold. For clients searching for
          brunette hair color & highlights near me that offer a soft, natural
          glow, babylights are the way to go.
        </p>
      </li>
      <li>
        <h6> Full Highlights</h6>
        <p>
          For those who want a more dramatic change, full highlights are a great
          option. Our stylists will strategically place highlights throughout
          your hair to create a high-contrast, multi-dimensional look. If you’ve
          been searching for brunette hair color & highlights near me that make
          a bold statement, SCENT’s full highlights service is perfect for you.
        </p>
      </li>
    </div>
  );
};

export default BrunetteColorNearMeService;
